import * as yup from 'yup'

import { centsToDollar, dollarToCents } from '@/lib/currency'

type AdvanceAmountParams = {
  minAmount?: number
  maxAmount?: number
}

export const createAdvanceAmountSchema = ({
  minAmount = 0,
  maxAmount = 0,
}: AdvanceAmountParams = {}) => {
  return yup.object({
    advance_amount: yup
      .string()
      .required('Amount is required')
      .test(
        'min-amount',
        `The amount entered is too low, please enter at least ${centsToDollar(minAmount)}.`,
        val => (val ? dollarToCents(+val) >= minAmount : false)
      )
      .test(
        'max-amount',
        `The amount entered is too high, please enter ${centsToDollar(maxAmount)} or lower.`,
        val => (val ? dollarToCents(+val) <= maxAmount : false)
      ),
  })
}

export type AdvanceAmountSchema = yup.InferType<
  ReturnType<typeof createAdvanceAmountSchema>
>
